function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { EventType } from '@wix/editor-platform-sdk-types';
import { ManifestHelpers } from './helpers';
import { createEditorPlatformManifestServicesError, EditorPlatformManifestServicesErrorCode } from './errors';
var _manifestHelpers = /*#__PURE__*/new WeakMap();
var _listeners = /*#__PURE__*/new WeakMap();
var _ManifestLifecycle_brand = /*#__PURE__*/new WeakSet();
var _eventHandler = /*#__PURE__*/new WeakMap();
// TODO: add errors
export class ManifestLifecycle {
  constructor(dm, editorPointerAPI) {
    this.dm = dm;
    this.editorPointerAPI = editorPointerAPI;
    _classPrivateMethodInitSpec(this, _ManifestLifecycle_brand);
    _classPrivateFieldInitSpec(this, _manifestHelpers, void 0);
    _classPrivateFieldInitSpec(this, _listeners, {
      manifests: new Set(),
      panels: new Set()
    });
    _classPrivateFieldInitSpec(this, _eventHandler, event => {
      const parsedEvent = _assertClassBrand(_ManifestLifecycle_brand, this, _parseDMEvent).call(this, event);
      if (!parsedEvent || !parsedEvent.args || !parsedEvent.args.eventType) {
        return;
      }
      const {
        eventType,
        eventPayload = {}
      } = parsedEvent.args;
      switch (eventType) {
        case EventType.appInstalled:
          void _assertClassBrand(_ManifestLifecycle_brand, this, _handleAppInstalledEvent).call(this, eventPayload);
          break;
        case EventType.componentAddedToStage:
        case EventType.widgetAdded:
          void _assertClassBrand(_ManifestLifecycle_brand, this, _handleComponentOrWidgetAddedEvent).call(this, eventPayload);
          break;
        case EventType.appUpdateCompleted:
          void _assertClassBrand(_ManifestLifecycle_brand, this, _handleAppInstalledEvent).call(this, eventPayload, {
            force: true
          });
          break;
        default:
          break;
      }
    });
    _classPrivateFieldSet(_manifestHelpers, this, new ManifestHelpers(this.dm, this.editorPointerAPI));
  }
  startListeners() {
    void _assertClassBrand(_ManifestLifecycle_brand, this, _processInstalledComponents).call(this);
    // load manifests for installed components
    _assertClassBrand(_ManifestLifecycle_brand, this, _startListeners).call(this);
  }
  onManifestLoad(cb) {
    _classPrivateFieldGet(_listeners, this).manifests.add(cb);
  }
  onPanelLoad(cb) {
    _classPrivateFieldGet(_listeners, this).panels.add(cb);
  }
  async handleApp(appData) {
    await _assertClassBrand(_ManifestLifecycle_brand, this, _triggerManifestLoad).call(this, this.prepareAppComponents(appData).map(appDataComponent => ({
      appDataComponent,
      force: true
    })));
    await _assertClassBrand(_ManifestLifecycle_brand, this, _triggerPanelLoad).call(this, (appData.components ?? []).map(appDataComponent => {
      return {
        appDataComponent,
        force: true
      };
    }));
  }
  prepareAppComponents(appData) {
    return (appData.components ?? []).map(compData => {
      var _appData$widgets, _widgetData$component;
      if (!compData.componentId) {
        return compData;
      }
      // @ts-expect-error appData.widgets is actually an object
      const widgetData = (_appData$widgets = appData.widgets) == null ? void 0 : _appData$widgets[compData.componentId];
      if (!widgetData) {
        return compData;
      }
      const builderConfigUrl = (_widgetData$component = widgetData.componentFields) == null ? void 0 : _widgetData$component.builderConfigUrl;
      if (!builderConfigUrl) {
        return compData;
      }
      const result = {
        ...compData,
        // @ts-expect-error
        data: {
          ...compData.data,
          builderConfigUrl
        }
      };
      return result;
    });
  }
}
function _startListeners() {
  this.dm.platform.subscribeOnAppEvents(_classPrivateFieldGet(_eventHandler, this));
  this.dm.platform.subscribeOnCustomAppEvents(_classPrivateFieldGet(_eventHandler, this));
}
function _parseDMEvent(event) {
  if (typeof event === 'string') {
    try {
      return JSON.parse(event);
    } catch (e) {
      // TODO: unify log/want messages
      console.warn('Failed to parse event string:', event, e);
      return null;
    }
  }
  return event;
}
async function _processInstalledComponents() {
  await _assertClassBrand(_ManifestLifecycle_brand, this, _triggerManifestLoad).call(this, _classPrivateFieldGet(_manifestHelpers, this).getInstalledComponents().map(appDataComponent => {
    return {
      appDataComponent
    };
  }));
  await _assertClassBrand(_ManifestLifecycle_brand, this, _triggerPanelLoad).call(this, _classPrivateFieldGet(_manifestHelpers, this).getInstalledComponents().map(appDataComponent => {
    return {
      appDataComponent
    };
  }));
}
async function _handleAppInstalledEvent(payload, options) {
  if (options === void 0) {
    options = {};
  }
  const appDefinitionId = payload.appDefinitionId;
  if (!appDefinitionId) {
    return;
  }
  const appData = this.dm.platform.getAppDataByAppDefId(appDefinitionId);
  const appDataComponents = appData == null ? void 0 : appData.components;
  await _assertClassBrand(_ManifestLifecycle_brand, this, _triggerManifestLoad).call(this, (appDataComponents ?? []).map(appDataComponent => {
    return {
      appDataComponent,
      force: options.force
    };
  }));
  await _assertClassBrand(_ManifestLifecycle_brand, this, _triggerPanelLoad).call(this, (appDataComponents ?? []).map(appDataComponent => {
    return {
      appDataComponent,
      force: options.force
    };
  }));
}
async function _handleComponentOrWidgetAddedEvent(_payload) {
  // TODO: optimization
}
async function _triggerManifestLoad(comps) {
  const results = await Promise.allSettled(comps.flatMap(comp => [..._classPrivateFieldGet(_listeners, this).manifests].map(cb => cb(comp))));
  const errorComponents = results.map(result => {
    if (result.status === 'rejected') {
      return result.reason;
    } else {
      return null;
    }
  }).filter(x => !!x);
  if (errorComponents.length) {
    console.error(createEditorPlatformManifestServicesError(EditorPlatformManifestServicesErrorCode.LoadComponentPanelError, 'some components failed to load').withMultipleErrors(errorComponents));
  }
}
async function _triggerPanelLoad(comps) {
  const results = await Promise.allSettled(comps.flatMap(comp => [..._classPrivateFieldGet(_listeners, this).panels].map(cb => cb(comp))));
  const errorComponents = results.map(result => {
    if (result.status === 'rejected') {
      return result.reason;
    } else {
      return null;
    }
  }).filter(x => !!x);
  if (errorComponents.length) {
    console.error(createEditorPlatformManifestServicesError(EditorPlatformManifestServicesErrorCode.LoadComponentPanelError, 'some components failed to load').withMultipleErrors(errorComponents));
  }
}
//# sourceMappingURL=ManifestLifecycle.js.map